import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Admin from '../views/Admin.vue';
import Card from '../views/Card.vue';
import Backoffice from '../views/Backoffice.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/admin',
    name: 'admin',
    component: Admin,
  },
  {
    path: '/backoffice',
    name: 'backoffice',
    component: Backoffice,
  },
  {
    path: '/:user',
    name: 'Card',
    component: Card,
  },
];


const router = new VueRouter({
  mode: 'history',
  routes,
});

export default router;
